import React, { useState } from 'react';
import { Building2, Map, FileText, Scale, AlertCircle, TrendingUp, TrendingDown, Minus, MapPin, PlusCircle } from 'lucide-react';
import { LegalFilingsModal } from './LegalFilingsModal';
export function WonkaDetailsTab() {
  const [legalTab, setLegalTab] = useState('ALL');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFilingIndex, setSelectedFilingIndex] = useState(0);
  const handleOpenModal = (index: number) => {
    setSelectedFilingIndex(index);
    setIsModalOpen(true);
  };
  return <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-3556">
      {/* Company Details - 3 Column Layout */}
      <div className="grid grid-cols-3 gap-6" data-id="element-3557">
        {/* Registration */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-3558">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-3559">Registration</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs" data-id="element-3560">
            <div data-id="element-3561">
              <p className="font-semibold text-gray-900" data-id="element-3562">SOS State</p>
              <p className="text-gray-600" data-id="element-3563">PA</p>
            </div>
            <div data-id="element-3564">
              <p className="font-semibold text-gray-900" data-id="element-3565">Founded Date</p>
              <p className="text-gray-600" data-id="element-3566">1971</p>
            </div>
            <div data-id="element-3567">
              <p className="font-semibold text-gray-900" data-id="element-3568">SOS Number</p>
              <p className="text-gray-600" data-id="element-3569">1971001</p>
            </div>
            <div data-id="element-3570">
              <p className="font-semibold text-gray-900" data-id="element-3571">Type</p>
              <p className="text-gray-600" data-id="element-3572">C-Corporation</p>
            </div>
            <div data-id="element-3573">
              <p className="font-semibold text-gray-900" data-id="element-3574">TIN Number</p>
              <p className="text-gray-600" data-id="element-3575">23-1971845</p>
            </div>
            <div data-id="element-3576">
              <p className="font-semibold text-gray-900" data-id="element-3577">DBAs</p>
              <p className="text-gray-600" data-id="element-3578">WONKA CHOCOLATE FACTORY</p>
            </div>
            <div data-id="element-3579">
              <p className="font-semibold text-gray-900" data-id="element-3580">Domestic / Foreign</p>
              <p className="text-gray-600" data-id="element-3581">Domestic</p>
            </div>
            <div data-id="element-3582">
              <p className="font-semibold text-gray-900" data-id="element-3583">Entity Type</p>
              <p className="text-gray-600" data-id="element-3584">Private Company</p>
            </div>
          </div>
        </div>

        {/* Information */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4" data-id="element-3585">
          <h3 className="text-sm font-bold text-gray-900 mb-3" data-id="element-3586">Information</h3>
          <div className="grid grid-cols-2 gap-y-2 gap-x-4 text-xs mb-3" data-id="element-3587">
            <div data-id="element-3588">
              <p className="font-semibold text-gray-900" data-id="element-3589">SIC</p>
              <p className="text-gray-600" data-id="element-3590">2064 - CANDY & CONFECTIONERY</p>
            </div>
            <div data-id="element-3591">
              <p className="font-semibold text-gray-900" data-id="element-3592">Ticker</p>
              <p className="text-gray-600" data-id="element-3593">--</p>
            </div>
            <div data-id="element-3594">
              <p className="font-semibold text-gray-900" data-id="element-3595">NAICS</p>
              <p className="text-gray-600" data-id="element-3596">
                311352 - CONFECTIONERY MANUFACTURING
              </p>
            </div>
            <div data-id="element-3597">
              <p className="font-semibold text-gray-900" data-id="element-3598">Approximate Revenue</p>
              <p className="text-gray-600" data-id="element-3599">~$285 Million</p>
            </div>
          </div>
          <div className="text-xs" data-id="element-3600">
            <p className="font-semibold text-gray-900 mb-0.5" data-id="element-3601">Description</p>
            <p className="text-gray-600 line-clamp-3" data-id="element-3602">
              Wonka Industries Ltd. is a world-renowned confectionery
              manufacturer specializing in innovative candy products. Known for
              the Everlasting Gobstopper, Wonka Bar, and other magical treats.
              "A little nonsense now and then is relished by the wisest men."
            </p>
            <button className="text-indigo-600 hover:text-indigo-700 font-medium mt-1" data-id="element-3603">
              More
            </button>
          </div>
        </div>

        {/* Location */}
        <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-4 flex flex-col" data-id="element-3604">
          <div className="flex justify-between items-start mb-2" data-id="element-3605">
            <h3 className="text-sm font-bold text-gray-900" data-id="element-3606">Location</h3>
            <Map className="w-4 h-4 text-indigo-600" data-id="element-3607" />
          </div>
          <div className="text-xs text-gray-600 mb-2" data-id="element-3608">
            <p data-id="element-3609">1 CHOCOLATE AVENUE</p>
            <p data-id="element-3610">HERSHEY, PA 17033, US</p>
          </div>
          <div className="flex-1 bg-gray-100 rounded-lg border border-gray-200 overflow-hidden max-h-[150px]" data-id="element-3611">
            <img src="https://cdn.magicpatterns.com/uploads/jLJSKVWf6UT7uWfheF4Dvi/Gemini_Generated_Image_ju8ib2ju8ib2ju8i.png" alt="Wonka Chocolate Factory - Hershey, PA" className="w-full h-full object-cover" data-id="element-3612" />
          </div>
        </div>
      </div>

      {/* Legal Filings */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-3613">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50/50" data-id="element-3614">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-3615">Legal Filings (3)</h3>
          <div className="flex bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden text-sm font-medium" data-id="element-3616">
            {['ALL', 'LAWSUITS', 'LIENS', 'UCC', 'BANKRUPTCY'].map(tab => <button key={tab} onClick={() => setLegalTab(tab)} className={`px-4 py-2 border-r border-gray-200 last:border-r-0 flex items-center gap-2 transition-colors ${legalTab === tab ? 'bg-gray-100 text-gray-900' : 'text-gray-500 hover:bg-gray-50 hover:text-gray-700'}`} data-id="element-3617">
                {tab === 'LAWSUITS' && <Scale className="w-4 h-4" data-id="element-3618" />}
                {tab === 'LIENS' && <FileText className="w-4 h-4" data-id="element-3619" />}
                {tab === 'UCC' && <Building2 className="w-4 h-4" data-id="element-3620" />}
                {tab === 'BANKRUPTCY' && <AlertCircle className="w-4 h-4" data-id="element-3621" />}
                {tab}
              </button>)}
          </div>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-3622">
          {(legalTab === 'ALL' || legalTab === 'LIENS') && <button onClick={() => handleOpenModal(0)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-3623">
              <div className="flex items-center gap-4" data-id="element-3624">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-3625">
                  <FileText className="w-5 h-5 text-gray-500" data-id="element-3626" />
                </div>
                <div className="text-left" data-id="element-3627">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-3628">
                    <h4 className="font-bold text-gray-900" data-id="element-3629">
                      DAUPHIN COUNTY RECORDER
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-green-500" title="Released" data-id="element-3630"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-3631">
                    MECHANIC'S LIEN • RELEASED
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-3632">
                <p className="font-medium text-gray-900" data-id="element-3633">3/22/2017</p>
                <p className="text-sm text-gray-500" data-id="element-3634">$8,500</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'LAWSUITS') && <button onClick={() => handleOpenModal(1)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-3635">
              <div className="flex items-center gap-4" data-id="element-3636">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-3637">
                  <Scale className="w-5 h-5 text-gray-500" data-id="element-3638" />
                </div>
                <div className="text-left" data-id="element-3639">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-3640">
                    <h4 className="font-bold text-gray-900" data-id="element-3641">
                      SLUGWORTH V. WONKA INDUSTRIES LTD.
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-green-500" title="Dismissed" data-id="element-3642"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-3643">
                    CIVIL LAWSUIT • TRADE SECRET THEFT • DISMISSED
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-3644">
                <p className="font-medium text-gray-900" data-id="element-3645">3/15/2018</p>
                <p className="text-sm text-gray-500" data-id="element-3646">Dismissed</p>
              </div>
            </button>}

          {(legalTab === 'ALL' || legalTab === 'UCC') && <button onClick={() => handleOpenModal(2)} className="w-full p-5 flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-3647">
              <div className="flex items-center gap-4" data-id="element-3648">
                <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center shrink-0" data-id="element-3649">
                  <Building2 className="w-5 h-5 text-gray-500" data-id="element-3650" />
                </div>
                <div className="text-left" data-id="element-3651">
                  <div className="flex items-center gap-2 mb-0.5" data-id="element-3652">
                    <h4 className="font-bold text-gray-900" data-id="element-3653">
                      PNC EQUIPMENT FINANCE
                    </h4>
                    <div className="w-2 h-2 rounded-full bg-blue-500" title="Active" data-id="element-3654"></div>
                  </div>
                  <p className="text-sm text-gray-500" data-id="element-3655">
                    UCC FILING • PRODUCTION EQUIPMENT
                  </p>
                </div>
              </div>
              <div className="text-right" data-id="element-3656">
                <p className="font-medium text-gray-900" data-id="element-3657">6/12/2024</p>
                <p className="text-sm text-gray-500" data-id="element-3658">Active</p>
              </div>
            </button>}
        </div>
      </div>

      {/* News */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-3659">
        <div className="p-5 border-b border-gray-200" data-id="element-3660">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-3661">News</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-3662">
          <table className="w-full text-sm text-left" data-id="element-3663">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-3664">
              <tr data-id="element-3665">
                <th className="px-5 py-3 font-medium" data-id="element-3666">Date</th>
                <th className="px-5 py-3 font-medium" data-id="element-3667">Title</th>
                <th className="px-5 py-3 font-medium" data-id="element-3668">Sentiment</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-3669">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-3670">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-3671">
                  Mar 20, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-3672">
                  Wonka Industries Launches Revolutionary Everlasting Gobstopper
                  2.0 — Sales Surge 40% in First Week
                </td>
                <td className="px-5 py-4" data-id="element-3673">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-3674">
                    <TrendingUp className="w-3.5 h-3.5" data-id="element-3675" />
                    Positive
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-3676">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-3677">
                  Feb 14, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-3678">
                  Golden Ticket Promotion Drives Record Valentine's Day Sales —
                  Five Lucky Winners Announced
                </td>
                <td className="px-5 py-4" data-id="element-3679">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-3680">
                    <TrendingUp className="w-3.5 h-3.5" data-id="element-3681" />
                    Positive
                  </span>
                </td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-3682">
                <td className="px-5 py-4 text-gray-500 whitespace-nowrap" data-id="element-3683">
                  Jan 05, 2026
                </td>
                <td className="px-5 py-4 text-gray-900 font-medium" data-id="element-3684">
                  Wonka Industries Expands Distribution to 12 New Countries in
                  Asia-Pacific Region
                </td>
                <td className="px-5 py-4" data-id="element-3685">
                  <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-3686">
                    <TrendingUp className="w-3.5 h-3.5" data-id="element-3687" />
                    Positive
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Affiliated Companies */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-3688">
        <div className="p-5 border-b border-gray-200" data-id="element-3689">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-3690">
            Affiliated Companies
          </h3>
        </div>
        <div className="overflow-x-auto" data-id="element-3691">
          <table className="w-full text-sm text-left" data-id="element-3692">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-3693">
              <tr data-id="element-3694">
                <th className="px-5 py-3 font-medium" data-id="element-3695">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-3696">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-3697">Country</th>
                <th className="px-5 py-3 font-medium w-12" data-id="element-3698"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-3699">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-3700">
                <td className="px-5 py-3 text-indigo-600" data-id="element-3701">
                  WONKA INDUSTRIES INC.
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3702">Parent Company</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3703">US</td>
                <td className="px-5 py-3" data-id="element-3704">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200" data-id="element-3705">
                    Monitored
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* Branch Offices */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-3706">
        <div className="p-5 border-b border-gray-200" data-id="element-3707">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-3708">Branch Offices</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-3709">
          <table className="w-full text-sm text-left" data-id="element-3710">
            <thead className="bg-gray-50 text-gray-500 border-b border-gray-200" data-id="element-3711">
              <tr data-id="element-3712">
                <th className="px-5 py-3 font-medium" data-id="element-3713">Name</th>
                <th className="px-5 py-3 font-medium" data-id="element-3714">Type</th>
                <th className="px-5 py-3 font-medium" data-id="element-3715">Address</th>
                <th className="px-5 py-3 font-medium" data-id="element-3716">Country</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200" data-id="element-3717">
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-3718">
                <td className="px-5 py-3 text-gray-900" data-id="element-3719">
                  WONKA CHOCOLATE FACTORY
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3720">
                  Headquarters / Factory
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3721">
                  1 Chocolate Avenue, Hershey, PA 17033
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3722">US</td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-3723">
                <td className="px-5 py-3 text-gray-900" data-id="element-3724">
                  WONKA DISTRIBUTION CENTER
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3725">Distribution Hub</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3726">
                  500 Sweet Street, Chicago, IL 60601
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3727">US</td>
              </tr>
              <tr className="hover:bg-gray-50 transition-colors" data-id="element-3728">
                <td className="px-5 py-3 text-gray-900" data-id="element-3729">WONKA WEST COAST</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3730">Regional Office</td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3731">
                  100 Candy Lane, San Francisco, CA 94102
                </td>
                <td className="px-5 py-3 text-gray-500" data-id="element-3732">US</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {isModalOpen && <LegalFilingsModal onClose={() => setIsModalOpen(false)} initialIndex={selectedFilingIndex} company="wonka" data-id="element-3733" />}
    </div>;
}